export var detailsBtn = {
  padding: '0.6em',
  '& > i': {
    margin: 0
  }
};
export var contactsTableWrap = {
  marginBottom: '2.5em',
  '& > div': {
    margin: 0
  }
};